import React from 'react';
import styles from './HomePage.module.css';
import { allProducts } from "./../API/ProductsAPI";
import { NavLink } from "react-router-dom";

const HomePage = (props) => {
    const productsId = [19, 2, 7, 10, 1]
    debugger
    return (
        <div className={styles.container}>

            <NavLink to="/shop" className={styles.productsLink}>
                <span className={styles.title}>Produsele noastre</span>
            </NavLink>

            <div className={styles.products}>
                {
                    productsId.map((id) => {
                        const product = allProducts.find((product) => product.id === id);
                        return product
                            ? (<div key={product.id} className={styles.productCard}>
                                <NavLink to={`/product/${product.id}`} className={styles.link}>
                                    <div className={styles.imageContainer}>
                                        <img src={product.image} alt={product.name} className={styles.image} />
                                    </div>
                                    <h3 className={styles.productName}>{product.name}</h3>
                                    <p className={styles.productPrice}>{product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} RON</p>
                                </NavLink>
                            </div>)
                            : null
                    })
                }
            </div>

            <NavLink to="/contact" className={styles.productsLink}>
                <span className={styles.title}>Contacte</span>
            </NavLink>

            <div className={styles.contacts}>
                <div className={styles.contact}>
                    <span className={styles.city}>București</span>

                    <div className={styles.address}>
                        <a href="tel:+40748556699" className={styles.phone}>+40 748 55 66 99</a>
                        <a href="https://www.google.com/maps/place/Altep+România/@44.4267161,25.9978653,17z/data=!3m1!4b1!4m6!3m5!1s0x40b20167a836c69f:0x7f3f2adf99b88266!8m2!3d44.4267161!4d26.0004402!16s%2Fg%2F11j22x57c1?entry=ttu&g_ep=EgoyMDI0MTIwNC4wIKXMDSoASAFQAw%3D%3D"
                            className={styles.mapsLink} target="_blank">
                            <i className="fa-solid fa-location-dot" />
                            <span>Str. Valea Cascadelor 21, Militari</span>
                        </a>
                    </div>

                </div>
                <div className={styles.contact}>
                    <span className={styles.city}>Galați</span>
                    <div className={styles.address}>
                        <a href="tel:+40757994455" className={styles.phone}>+40 757 99 44 55</a>
                        {/* <a href="https://www.google.com/maps/place/Altep+România/@44.4267161,25.9978653,17z/data=!3m1!4b1!4m6!3m5!1s0x40b20167a836c69f:0x7f3f2adf99b88266!8m2!3d44.4267161!4d26.0004402!16s%2Fg%2F11j22x57c1?entry=ttu&g_ep=EgoyMDI0MTIwNC4wIKXMDSoASAFQAw%3D%3D"
                            className={styles.mapsLink}>
                            <i className="fa-solid fa-location-dot" />
                            <span>Str. Făgărașului 79, Ghimbav</span>
                        </a> */}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default HomePage;